<template>
  <div class="timetable">
    <TimeScale v-on:click="handleClick($event)"></TimeScale>
    <div class="bookings">
      <Booking v-for="booking in bookings"
        :key="booking.id"
        :data="booking">
      </Booking>
    </div>
  </div>
</template>

<script>
import TimeScale from '@/components/TimeScale'
import Booking from '@/components/Booking'

export default {
  name: 'TimeTable',
  components: { TimeScale, Booking },
  props: ['bookings', 'date', 'roomId'],
  methods: {
    handleClick (e) {
      this.$router.push({
        name: 'BookingCreateView',
        params: { room: this.roomId, startTime: e, date: this.date }
      });
    }
  }
}
</script>

<style lang="scss" scoped>

.timetable {
  position: relative;
}

.bookings {
  width: calc(100% - 3em);
  position: absolute;
  top: 0;
  left: 3em;
  display: inline-block;
}

</style>



// WEBPACK FOOTER //
// src/components/TimeTable.vue